import React, {useState} from 'react';
import {Button} from '@material-ui/core';
import { db, storage } from './firebase';
import {selectUser} from './features/userSlice';
import {useSelector} from 'react-redux';
import firebase from 'firebase';
import {selectNewsId, selectNewsName} from './features/newsSlice';
import './ImageUpload.css';

function ImageUpload({ username }) {
    const user = useSelector(selectUser);
    const newsName = useSelector(selectNewsName);
    const [imageUrl, setImageUrl] = useState('');
    const [caption, setCaption] = useState('');
    const [image, setImage] = useState(null);
    const [progress, setProgress] = useState(0);
    const [url, setUrl] = useState("");
    const newsId = useSelector(selectNewsId);

    const handleAddNews = () => {
        const newsName = prompt("Enter a News Title");
        
        if(newsName) {
            db.collection("news").add({
                newsName: newsName,
            });
        }
        };

    const handleChange = (e) => {
        if(e.target.files[0]){
            setImage(e.target.files[0]);
        }
    }

    const handleUpload = () => {
        const uploadTask = storage.ref(`images/${image.name}`).put(image);
        uploadTask.on(
            "state_changed",
            (snapshot) => {
                //Progress---
                const progress = Math.round(
                    (snapshot.bytesTransferred/ snapshot.totalBytes) *100
                );
                setProgress(progress);
            },
            (error) => {
            console.log(error);
            alert(error.message);
            },
            () => {
            storage
                .ref("images")
                .child(image.name)
                .getDownloadURL()
                .then((url) => {
                    setUrl(url);
                // post image inside db
                    db.collection("news")
                    .doc(newsId)
                    .collection('newsEntry').add({
                        timestamp:firebase.firestore.FieldValue.serverTimestamp(),
                        caption: caption,
                        imageUrl: url,
                        user: user,
                        username:username,
                       
                    });
                    setProgress(0);
                    setCaption("");
                    setImage(null);
                });
            }
        ) 
    }
    return (
        <div className="imageupload">
            <input 
                type="text" 
                placeholder={`Write your Article for #  ${newsName}`}
                className="imageupload__caption"
                onChange={event =>setCaption(event.target.value)} 
                value={caption}
            />        
            <input 
                type="file" 
                onChange={handleChange}
            />
            <progress className="imageupload__progress" value={progress} max="100"/>
            <Button className="imageupload__button" onClick={handleUpload}>
                Upload your Article & Image
            </Button>
        </div>
    )
}

export default ImageUpload
